/**
 * Trả về Date cách hiện tại `days` ngày (dương = tương lai, âm = quá khứ).
 *
 * Tách khỏi dateUtil.ts (808 dòng) để các consumer boot-path — authenStore ← boot/axios,
 * boot/requireAuth, App.vue; và useAuth/useLang/useTheme — không kéo date-fns + locale vào
 * boot chunk chỉ vì cần helper tính hạn cookie này.
 */
export const addDateByDays = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};
